import { c as _c } from "react/compiler-runtime";
import { useIsHydrated } from '@cc-shopping/hooks/useIsHydrated';
import { usePathname } from 'next/navigation';
import type { MiniProductCardMarketplaceEntity } from './types';
export const ALIGN_MAP = {
  center: 'center',
  left: 'flex-start',
  none: 'normal',
  right: 'flex-end'
};
export const useReviewSelfReferenceCheck = marketplaceEntity => {
  const $ = _c(2);
  const isHydrated = useIsHydrated();
  const path = usePathname();
  if (!isHydrated || !marketplaceEntity?.reviewLink) {
    return false;
  }
  let t0;
  if ($[0] !== marketplaceEntity.reviewLink) {
    t0 = new URL(marketplaceEntity.reviewLink);
    $[0] = marketplaceEntity.reviewLink;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const offerReviewURL = t0;
  return path === offerReviewURL.pathname;
};